import { TranslationKey } from '@/shared/i18n';
import { PlanCategory } from '@/shared/types/Billing';

export type PricingCardFeatureItem = {
  labelKey: TranslationKey;
};

type PricingCardFeature = {
  // Short marketing description shown under the plan name.
  descriptionKey?: TranslationKey;
  features: PricingCardFeatureItem[];
};

const text = (labelKey: TranslationKey): PricingCardFeatureItem => ({ labelKey });

export const PRICING_CARD_FEATURES: Record<PlanCategory, PricingCardFeature> = {
  business: {
    descriptionKey: 'pricing.plan.businessDescription',
    features: [
      text('pricing.plan.businessFeature1'),
      text('pricing.plan.businessFeature2'),
      text('pricing.plan.businessFeature3'),
      text('pricing.plan.unlimitedRecording'),
    ],
  },
  creator: {
    descriptionKey: 'pricing.plan.creatorDescription',
    features: [
      text('pricing.plan.creatorFeature1'),
      text('pricing.plan.creatorFeature2'),
      text('pricing.plan.creatorFeature3'),
      text('pricing.plan.unlimitedRecording'),
    ],
  },
  creator_pro: {
    descriptionKey: 'pricing.plan.creatorProDescription',
    features: [
      text('pricing.plan.creatorProFeature1'),
      text('pricing.plan.creatorProFeature2'),
      text('pricing.plan.creatorProFeature3'),
      text('pricing.plan.unlimitedRecording'),
    ],
  },
  enterprise: {
    descriptionKey: 'pricing.plan.enterpriseDescription',
    features: [
      text('pricing.plan.enterpriseFeature1'),
      text('pricing.plan.enterpriseFeature2'),
      text('pricing.plan.enterpriseFeature3'),
      text('pricing.plan.enterpriseFeature4'),
      text('pricing.plan.unlimitedRecording'),
    ],
  },
  starter: {
    features: [],
  },
};
